import { render, staticRenderFns } from "./m_prize_page.vue?vue&type=template&id=25f8612e&scoped=true&"
import script from "./m_prize_page.vue?vue&type=script&lang=js&"
export * from "./m_prize_page.vue?vue&type=script&lang=js&"
import style0 from "./m_prize_page.vue?vue&type=style&index=0&id=25f8612e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f8612e",
  null
  
)

export default component.exports